import MissionCompletionModal from '@/components/MissionCompletionModal';
import { useMissionCheck } from '@/hooks/useMissionCheck';

/**
 * Global watcher: fires the celebration modal when the user completes a mission.
 * Auto-checks on mount (login/refresh). Other pages can trigger check() manually.
 */
export default function GlobalMissionWatcher({ isAuthenticated }) {
  const { pending, dismiss } = useMissionCheck();
  if (!isAuthenticated) return null;
  return <MissionCompletionModal completions={pending} onClose={dismiss} />;
}
